import { Component } from '@angular/core';
import { ONLStartWalletSession, PPIStartWalletSession } from './shared/models/session.model';
import { merge, fromEvent, of, tap, debounceTime } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ScriptService } from './shared/services/script.service';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private translate: TranslateService,
    private scriptService:ScriptService,
    private meta: Meta
    ) {
        translate.setDefaultLang('en');
        translate.use('en');
      }
  
  title = 'DigitalWalletApp';

  timeout:number=900000;
  timeout_PPI = 1800000;

  ngOnInit()
  {
    this.scriptService.loadGlia(); // Load Glia when the app starts

  merge(
    fromEvent(window,'mousemove'),
    fromEvent(window,'keypress'),
    fromEvent(window,'touchstart'),
    fromEvent(window,'blur'),
    of('load')
  ).pipe(tap((event:any)=>
  {
    //console.log('wallet session activity tracker activated');
  }),
  debounceTime(this.timeout),
  tap((event:any)=>
  {
    
    let sessionobj:ONLStartWalletSession=new ONLStartWalletSession();
    
    if(sessionStorage.getItem('ONLWalletSession') !=undefined)
    sessionobj=JSON.parse(sessionStorage.getItem('ONLWalletSession') || '{}');
    
    if(sessionobj !=null && sessionobj !=undefined && sessionobj.callBackURL !=undefined )
    {
    window.location.href=sessionobj.callBackURL;
    sessionStorage.clear();
    }
  })
  ).subscribe();

  merge(
        fromEvent(window, 'mousemove'),
        fromEvent(window, 'keypress'),
        fromEvent(window, 'touchstart'),
        fromEvent(window, 'blur'),
        of('load')
    ).pipe(
        tap(() => {
           // console.log('wallet session activity tracker activated (PPI)');
        }),
        debounceTime(this.timeout_PPI), // Use the same timeout
        tap(() => {
            let callbackUrl: string | undefined = undefined;

            // Check PPI session storage key
            const ppiSessionString = sessionStorage.getItem('PPIWalletSession');
            
            if (ppiSessionString) {
                // Cast to interface holding callBackURL property
                const ppiSession = JSON.parse(ppiSessionString) as PPIStartWalletSession;
                callbackUrl = ppiSession.callBackURL;
            }
            
            // Execute PPI redirect if callbackUrl is found
            if (callbackUrl) {
                console.log(`PPI session timed out. Redirecting to callback URL: ${callbackUrl}`);
                window.location.href = callbackUrl;
                sessionStorage.clear();
            }
        })
    ).subscribe();

    if (!environment.production) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
      console.log('🛡️ Security: Injected noindex meta tag for non-prod environment.');
    }

}

ngOnDestroy() {
  this.scriptService.unloadGlia(); // Unload Glia when the app is destroyed 
}

}


